"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DefaultButton = ({
  onClick: _onClick,
  classes,
  disabled,
  children
}) => _react.default.createElement("button", {
  type: "button",
  className: classes.button,
  onClick: e => _onClick(e),
  disabled: disabled
}, children);

var _default = (0, _reactJss.default)(theme => ({
  button: {
    padding: "0 ".concat(theme.sizes.inputHeight / 2, "px"),
    fontSize: theme.typography.inputFontSize,
    lineHeight: "".concat(theme.sizes.inputHeight, "px"),
    height: theme.sizes.inputHeight,
    borderWidth: 0,
    borderRadius: theme.sizes.borderRadius,
    whiteSpace: 'nowrap',
    color: 'white',
    backgroundColor: theme.colors.accent,
    cursor: 'pointer',
    display: 'inline-flex',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: (0, _polished.lighten)(0.1, theme.colors.accent)
    },
    '&:focus': {
      outline: 'none'
    },
    '&:disabled': {
      opacity: 0.6,
      pointerEvents: 'none'
    }
  }
}))(DefaultButton);

exports.default = _default;